"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _styling = require("../../toolkit/styling");

var _dimen = require("../../toolkit/dimen");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DataGrid = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DataGrid, _Component);

  var _super = _createSuper(DataGrid);

  function DataGrid() {
    var _this;

    (0, _classCallCheck2["default"])(this, DataGrid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(DataGrid, [{
    key: "renderRow",
    value: function renderRow(items, index) {
      var _this2 = this;

      var textStyle = this.props.textStyle;
      var numRows = this.rows.length;
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: "row-".concat(index)
      }, items.map(function (item, columnIndex) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: item,
          className: (0, _styling.css)(_this2.styles.item, textStyle),
          style: {
            paddingBottom: numRows === index + 1 ? 0 : 10
          }
        }, item);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          title = _this$props.title,
          className = _this$props.className;

      if (this.rows.length === 0) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, title != null && /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.title)
      }, title), /*#__PURE__*/_react["default"].createElement("table", {
        className: (0, _styling.css)(this.styles.table)
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, this.rows.map(function (rowItems, index) {
        return _this3.renderRow(rowItems, index);
      }))));
    }
  }, {
    key: "numColumns",
    get: function get() {
      var _this$props$numColumn = this.props.numColumns,
          numColumns = _this$props$numColumn === void 0 ? 4 : _this$props$numColumn;

      var dimenStore = _dimen.DimenStore.instance();

      return dimenStore.isSmallScreen ? 2 : numColumns;
    }
  }, {
    key: "rows",
    get: function get() {
      var data = this.props.data;
      return _lodash["default"].chunk(Array.from(new Set(data)), this.numColumns);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          textBlack = _this$context$theming.theme.textBlack,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column"
        },
        authoritiesRow: {
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        authoritiesColumn: {
          display: "flex",
          flexBasis: "100%"
        },
        title: {
          fontSize: 16,
          textTransform: "capitalize",
          fontFamily: fonts.semibold,
          lineHeight: 1.5,
          color: textBlack,
          cursor: "default",
          marginBottom: 10
        },
        item: {
          fontSize: 14,
          textTransform: "capitalize",
          fontFamily: fonts.regular,
          lineHeight: 1.5,
          color: textBlack,
          paddingRight: 60,
          cursor: "default"
        },
        table: {
          tableLayout: "fixed"
        }
      });
    }
  }]);
  return DataGrid;
}(_react.Component), _class3.contextType = _providers.LegoContext, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "numColumns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numColumns"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "rows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "rows"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = DataGrid;
exports["default"] = _default;